
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Sediriswa seno se go letla go baakanya lenaane la metswako. O ka tsenya, wa tlosa kgotsa wa tseleganya
                lenaane la metswako.
                <br>
                Moanelwa yo <span class="highlight">␣</span> o emela sebaka.
                <br>
                Moanelwa yo <span class="highlight">↩︎</span> o emela go kgaoga ga mola. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Dipopego tsa go laisa...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Re thuse ka metswako`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Netefatsa dijalo`,
's03e9c8114521b998': `Ke tla fetola metswako`,
's05ec315d9308091a': `Aekhone ya dikhutlo tsa khoutu ya dibara`,
's061eb5af92512c85': `E bolokilwe! A o ka thusa ka e nngwe?`,
's06847c221c4c0bc1': `Ke rata go tlhama sedirisiwa sa go [tlhalosa tiriso ya gago]...`,
's06f6c6f99db6b552': `Tshimologo`,
's081e2ad82db71e1d': `Boleng jo bo Kopantsweng`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `ditokomane tse di kgethegileng`,
's0bb2d48532acc455': `Laisolola CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Dira gore setshwantsho se se ka sa nna mosola`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Khansela sejalo`,
's11a18a69b30b65ed': `Re thuse go baakanya diphoso mo lenaaneng la ditswaki`,
's1205d5f6fccf8e69': `Boleng jwa Thoto`,
's15d64a0a6715285a': `Selotlolo se sesha`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Lefelo la tlhopho`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Re thuse go baakanya tshedimosetso ya dikotla`,
's1e00019dc454872d': `Tsweetswee naya leina la setsha o dirisa tshwano ya leina la setsha.`,
's1e49126af0935a5b': `Lenaane la dikumo tse di dirisang sedirisiwa seno`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Kwala thoto`,
's300b3a6ee4e1252d': str`Tshwantshanyo e e bokoa ${0}%`,
's33f786bb6b4f0cf4': `Dipholo tsa Sejalo`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Botsa morafe pele`,
's36d86adc823cbfa6': `Pele ga o tlhama thoto e ntšhwa, buisana ka yone le baagi:`,
's3781d25aa51a736c': `Ditokomane tsa Enjene ya Folksonomy`,
's383ae4449428b61e': `Seta gape sejalo`,
's39bcf88721a1e8ee': `Seta gape tlhopho`,
's39e14e14300694c7': `Ditokomane le Dikaelo`,
's3b430cfa5c1fe7f4': str`Ditokomane tsa ${0}`,
's3f4e4b52f230a892': `Letsela la setshwantsho`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Setshwantsho se se fa gare`,
's42dd66b2441566fd': `Aekhone ya mo gare`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Fetola bogolo ka fa mojeng`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Palo ya Dikumo`,
's4df2f533c0c1e7d0': `Ditaolo tsa setshwantsho`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Sutisa tlhopho`,
's4f751fb9b3ed766c': `Go Tlhama Popego e Ntšhwa`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Tsenya leina la setsha...`,
's55d7249883a98ca1': `ka ga thoto eno mo wiki ya Dintlha tsa Dijo tse di Buletsweng`,
's565867d84c04aea2': `Dipopego tsa go tlhotlha...`,
's5666afe5cd0166de': `Tsweetswee baakanya diphoso kgotsa fetola mokwalo pele ga o tlhomamisa`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Go laisa dikumo...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Re thuse go baakanya tshedimosetso ya phepo.`,
's5dd6f12783fca34f': `Tseleganya lenaane la ditswaki`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Setshwantsho se se Kgaotsweng`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Tshwantshano e e Siameng ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Tokomane`,
's787dd11bed0dc88a': `Fetola bogolo ka fa molemeng`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Ithute go le gontsi ka go tlhama dithoto le dikaelo:`,
's8038273de2cf8b73': `Tsweetswee tlhopha kgaolo e o tla e remang.`,
's839cc2908a5387f2': `Tlhotlha dikhoutu tsa dibara...`,
's86197dcf3e96af64': `Batla le go batla dipopego tse di leng teng`,
's8a63be30a129a59c': `Fetola bogolo jwa botlase`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Fetola bogolo kwa godimo ka fa mojeng`,
's8db84aa4bc949af2': `Kwala thoto e ntšhwa`,
's8f839a03997a16d7': `Leba Kumo`,
's901ae1e236ac45d3': `Khansela phimolo`,
's907f7a97c6b29425': `Ela tlhoko gore sekao sa tshedimosetso se ka nna sa fetolwa. Dirisa ka kotsi ya gago.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ditswaki :`,
's9a7f60fce090ecaf': `E paletswe ke go laisa dipopego. Tsweetswee leka gape moragonyana.`,
's9b87abd68fb9df45': `Ga e bonwe? Tlhama selotlolo se sešwa {value}`,
's9c0f52425fd2f07e': `E ka nna ya se Tshwane`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Ga go na maduo a a leng teng`,
'sa548778b24054030': `Batlisisa dithoto tsotlhe tse di ntshitsweng go tswa mo porojekeng ya Folksonomy Engine. Dithoto tseno di tlamela ka metadata e nngwe le dintlha ka ga ditlhagiswa mo polokelotshedimosetsong ya Dintlha tsa Dijo tse di Buletsweng.`,
'sa63907958bd0ec4b': `Fetola bogolo kwa godimo ka fa molemeng`,
'sa95b4224f685a36a': `Tswala mofuta`,
'sab56a1d439576fd6': `Aekhone ya tshitshinyo`,
'sac47ea2901d04c15': `Fetola bogolo kwa tlase ka fa molemeng`,
'sb125227d436c2925': `Batla kgopolo ya gago ya thoto mo polokelotshedimosetsong ya dithoto e e leng teng:`,
'sb125568d43642e6f': `Araba dipotso ka setlhagiswa.`,
'sb1c538e038f9b214': str`Tshwantshano e e Siameng Thata ${0}%`,
'sb28639570ff3b852': `lenaane la dithoto tsotlhe`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Fa o sena go netefatsa gore thoto ya gago ga e yo mme baagi ba dumela gore e mosola, o tlhoka go e kwala pele mo wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ga go na dikumo tse di bonweng tsa lefelo leno.`,
'sb7f72e4c8a2d3357': `Tlhotlha boleng...`,
'sb8178320160f84ea': `Bontsha sejalo`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Ditemogo tsotlhe di arabilwe! Re lebogela thuso ya gago!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Boleng jo bo Tshwanang`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Fetola bogolo jwa bogodimo`,
'sc1c08d0cbcc3bd24': `Ga e Tshwane`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Paakanyo e e tshitshintsweng`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Sutisa setshwantsho`,
'sc895972c88d38ca5': `Thoto ya setso`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Mela`,
'scb3b0671d7b7f640': `Boleng jo bošwa`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Tsenela Motlotlo wa Slack`,
'scdb6cad0b92721bf': `Ga go na dithoto tse di bonweng.`,
'scf23a05631f93732': `Netefatsa Phimola`,
'scfed2f270ef6a3aa': `Tlhopha lefelo`,
'sd1022bc1ef9204f7': `Setshwantsho se se atolosiwang`,
'sd1077c055cf9ba6b': `Re thuse go netefatsa lenaane la metswako ya setlhagiswa.`,
'sd698d21ddecba56b': `Heela! O ka re thusa go tokafatsa tshedimosetso ya setlhagiswa ka go araba dikarolo tse di latelang:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Tlhola gore a thoto e setse e le teng`,
'sdbf806fefc584115': `O tshwanetse go bona`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Re thuse go baakanya mopeleto wa metswako.`,
'sdca5deead576ceee': `Fetola bogolo kwa tlase ka fa mojeng`,
'sdcc2555c5dde524f': `A o tlhomamisa gore o batla go phimola ntlha eno? Tiro eno ga e ka ke ya dirololwa.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Tlosa mosola`,
'se5127cf0f92e7e48': `Tlhabo-botlhale: gape o ka bona`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ke tla tshitshinya dijalo tse di botoka`,
'seea3800e27baa686': `Dikumo ka bongwe`,
'sefaba4adc4ec9219': `Dipharologantsho tsa Thuto ya Setso`,
'seffa8ca49175b5f0': `Dithoto tse di itebagantseng le motho`,
'sf44a6b3b232c28ea': str`Emisetsa boleng jwa ga jaana ka ${0}`,
'sf4cd86a2f5ef2588': `Khoutu ya Kumo`,
'sf57a61152168cc81': `Re thuse go baakanya go lemogwa ga metswako`,
'sf88b90b8ba23871c': `Tshwantshanyo e e sa itsiweng`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Leina la thoto:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Boleng jo bo tsamaelanang`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  